import { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/shared/icons';
import useIsPWA from '@/hooks/utilities/useIsPWA';
import { useDetectPlatform } from '@/hooks/utilities/useDetectPlatform';
import useAppDetails from '@/hooks/utilities/useAppDetails';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
import useDeepLink from '@/hooks/utilities/useDeepLink';
enum OnboardStates {
  Default = 'default',
  Web = 'web',
  Download = 'donwload',
}
export default function OnboardingLayout({
  runAuthFlow
}) {
  //removePWA means they are using the native app
  const [removePWA] = useLocalStorage('removePWA', false);
  const [currentState, setCurrentState] = useState(OnboardStates.Web);
  const isPWA = useIsPWA();
  const platform = useDetectPlatform();
  const {
    isNativeApp
  } = useAppDetails();
  useEffect(() => {
    if (isPWA || removePWA) {
      setCurrentState(OnboardStates.Web);
    }
  }, [isPWA]);
  useEffect(() => {
    console.log('User platform:', platform);
    // You can add conditional logic based on the platform here
  }, [platform]);
  const touchHandlerName = useTouchHandlerName();
  const {
    startDeepLinkFlow
  } = useDeepLink();
  return <div data-sentry-component="OnboardingLayout" data-sentry-source-file="OnboardingLayout.tsx">
      <div className='w-full min-h-screen p-2 flex flex-col justify-center items-center relative  pb-12'>
        <div style={{
        backgroundImage: `url('/static/images/refer-1.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '70vmax'
      }} className={`flex-grow w-full  my-2 rounded-md ${currentState === OnboardStates.Web && 'mt-2'}`}>
          <div className='z-10 flex flex-col inner-onboard'>
            <>
              <div className='ta-c items-center justify-start text-genius-pink space-x-2 mt-24'>
                <Image src='/static/genius.png' height={36} width={36} alt='logo' data-sentry-element="Image" data-sentry-source-file="OnboardingLayout.tsx" />
                <div className='mt-12 text-purple-300 text-lg z-20'>Welcome</div>
              </div>
              <div className='text-center text-6xl font-medium tracking-tighter text-genius-cream lg:mt-28 mt-12'>
                Genius
              </div>
              <div className='flex flex-col w-full px-2 mt-4 lg:mt-0'>
                <div className='flex flex-col items-center justify-center lg:px-4'>
                  <div className='w-full absolute bottom-6 px-2'>
                    {!isNativeApp ? <>
                        {' '}
                        <Button variant='pink' className='rounded-full w-full py-8 bg-genius-pink ' {...{
                      [touchHandlerName]: () => {
                        startDeepLinkFlow();
                      }
                    }}>
                          Download App
                        </Button>
                      </> : <>
                        {' '}
                        <Button className='w-full mt-2 lg:w-3/4 rounded-full bg-genius-pink text-genius-indigo  h-12' onClick={() => runAuthFlow('genius-google')}>
                          <Image src='/static/images/google_logo.png' width={16} height={16} alt='google' className='mr-6' />
                          Sign in with Google
                        </Button>
                        <Button className='w-full mt-2 lg:w-3/4 rounded-full bg-genius-pink text-genius-indigo  h-12' onClick={() => runAuthFlow('apple')}>
                          <Icons.apple className='mr-6 h-4 w-4' />
                          Sign in with Apple
                        </Button>
                      </>}
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>;
}